$(function () {
    "use strict";
    if (currentUrl.includes('products')) {
        if ($.fn.DataTable) {
            if ($.fn.DataTable.isDataTable('#productsTable')) {
                $('#productsTable').DataTable().clear().destroy();
            }
            
            $('#productsTable').DataTable({

                "lengthMenu": [[25, 50, 100, -1], [25, 50, 100, "All"]],
                responsive: true,
                colReorder: true,
                "order": [[ 0, "desc" ]],
                language: {
                    search: "<i class='fa fa-search search-icon'></i>",
                    lengthMenu: '_MENU_ ',
                    paginate : {
                        first    : '<i class="fa fa-angle-double-left"></i>',
                        last     : '<i class="fa fa-angle-double-right"></i>',
                        previous : '<i class="fa fa-angle-left"></i>',
                        next     : '<i class="fa fa-angle-right"></i>'
                    }
                },
                pagingType : 'full_numbers',
                processing: true,
                serverSide: true,
                ajax: "/products",
                columns: [
                    {
                        data: 'sku',
                        name: 'sku',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'name',
                        name: 'name',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'photos',
                        name: 'photos',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'locations',
                        name: 'locations',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'is_bundle',
                        name: 'is_bundle',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'packages',
                        name: 'packages',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'actions',
                        name: 'actions',
                        orderable: false,
                        searchable: false
                    }
                ],
                "drawCallback": function() {
                    initializeProductImageHover();
                },
                initComplete: function () {
                    let api = this.api();
                    let searchBox = $('#productsTable_filter input');

                    // remove default event
                    searchBox.off();

                    // add debounce
                    let debounceTimer;
                    searchBox.on('input', function () {
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => {
                            api.search(this.value).draw();
                        }, 500); // 500ms delay
                    });
                }
            });
        }
    }

});


function initializeProductImageHover() {
    let hoverTimeout;
    
    $(document).off('mouseenter mouseleave', '.product-name-hover');
    
    $(document).on('mouseenter', '.product-name-hover', function(e) {
        const imageUrl = $(this).data('image');
        if (!imageUrl) return;
        
        clearTimeout(hoverTimeout);
        
        $('.product-hover-popup').remove();
        
        const popup = $(`
            <div class="product-hover-popup" style="position: fixed; z-index: 9999; background: white; border: 1px solid #ddd; border-radius: 8px; padding: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); max-width: 300px; pointer-events: none;">
                <img src="${imageUrl}" style="max-width: 100%; max-height: 350px; object-fit: contain; border-radius: 4px;" onerror="this.style.display='none'" />
            </div>
        `);
        
        $('body').append(popup);
        
        const popupHeight = popup.outerHeight();
        const popupWidth = popup.outerWidth();
        const windowHeight = $(window).height();
        const windowWidth = $(window).width();
        
        let leftPos = e.pageX + 15;
        let topPos = e.pageY - popupHeight - 15;
        
        if (leftPos + popupWidth > windowWidth) {
            leftPos = e.pageX - popupWidth - 15;
        }
        if (topPos < $(window).scrollTop()) {
            topPos = e.pageY + 15;
        }
        
        popup.css({
            left: leftPos,
            top: topPos
        });
    });
    
    $(document).on('mouseleave', '.product-name-hover', function() {
        hoverTimeout = setTimeout(() => {
            $('.product-hover-popup').remove();
        }, 150);
    });
}


$(document).on('click', '.deletProductButton', function(e) {
    e.preventDefault();
    var productId = $(this).data('id');

    swal({
        title: 'Are you sure?',
        text: 'Delete this product!',
        icon: 'warning',
        buttons: {
            cancel: {
                text: 'Cancel',
                value: null,
                visible: true,
                className: 'btn btn-default',
                closeModal: true,
            },
            confirm: {
                text: 'Delete',
                value: true,
                visible: true,
                className: 'btn btn-danger',
                closeModal: true
            }
        }
    }).then((result) => {
        if (result) {
            // User confirmed deletion
            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                method: 'get',
                url: '/products/delete',
                data: { productId: productId },
                success: function(response) {

                    if(response.status=='success'){
                        swal('Deleted!', response.message, 'success');
                    }else{
                        swal('Error!', 'Product Not Found', 'error');
                    }
                    setTimeout(function () {
                        location.reload();
                    }, 200);
                },
                error: function(error) {
                    // Handle error
                    console.log(error);
                    swal('Error!', 'An error occurred while deleting the product.', 'error');
                }
            });
        }
    });
});

